// src/features/ranking/utils/ranking.utils.ts

export const getCurrentMonth =
  (): string => {
    const now =
      new Date();

    const year =
      now.getFullYear();

    const month =
      String(
        now.getMonth() + 1,
      ).padStart(
        2,
        '0',
      );

    return `${year}-${month}`;
  };


export const formatMonthTitle = (
  monthValue: string,
): string => {
  const [
    year,
    month,
  ] =
    monthValue
      .split('-')
      .map(Number);

  if (
    !year ||
    !month
  ) {
    return monthValue;
  }

  return `${year}년 ${month}월`;
};


export const moveMonth = (
  monthValue: string,
  amount: number,
): string => {
  const [
    year,
    month,
  ] =
    monthValue
      .split('-')
      .map(Number);

  const date =
    new Date(
      year,
      month - 1 + amount,
      1,
    );

  const nextYear =
    date.getFullYear();

  const nextMonth =
    String(
      date.getMonth() + 1,
    ).padStart(
      2,
      '0',
    );

  return `${nextYear}-${nextMonth}`;
};


export const getInitial = (
  nickname: string,
): string => {
  const trimmed =
    nickname.trim();

  if (!trimmed) {
    return '?';
  }

  return trimmed
    .charAt(0)
    .toUpperCase();
};


export const getRankBadgeClassName = (
  rank: number,
): string => {
  if (rank === 1) {
    return 'bg-amber-100 text-amber-700';
  }

  if (rank === 2) {
    return 'bg-slate-200 text-slate-700';
  }

  if (rank === 3) {
    return 'bg-orange-100 text-orange-700';
  }

  return 'bg-gray-100 text-gray-600';
};


export interface PodiumStyle {
  wrapper: string;
  badge: string;
  avatar: string;
  order: string;
}


export const getPodiumStyle = (
  rank: number,
): PodiumStyle => {
  if (rank === 1) {
    return {
      wrapper:
        'border-amber-200 bg-gradient-to-b from-amber-50 to-white shadow-md sm:-translate-y-3',

      badge:
        'bg-amber-400 text-white',

      avatar:
        'h-20 w-20 border-4 border-amber-300 sm:h-24 sm:w-24',

      order:
        'order-1 sm:order-2',
    };
  }

  if (rank === 2) {
    return {
      wrapper:
        'border-slate-200 bg-gradient-to-b from-slate-50 to-white',

      badge:
        'bg-slate-400 text-white',

      avatar:
        'h-16 w-16 border-4 border-slate-300 sm:h-20 sm:w-20',

      order:
        'order-2 sm:order-1',
    };
  }

  return {
    wrapper:
      'border-orange-200 bg-gradient-to-b from-orange-50 to-white',

    badge:
      'bg-orange-400 text-white',

    avatar:
      'h-16 w-16 border-4 border-orange-300 sm:h-20 sm:w-20',

    order:
      'order-3',
  };
};